<template>
  <HeraFormSwitch
    v-model="feeRequierd"
    :label="$$t('Type', 'tournmament-type-label')"
    name="feeRequierd"
    :true-label="$$t('Paid', 'options-paid')"
    :false-label="$$t('Free', 'options-free')"
    :true-value="true"
    :false-value="false"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import HeraFormSwitch from '@/components/atoms/form/HeraFormSwitch';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentFeeTypeSetting',
  components: {
    HeraFormSwitch,
  },
  mixins: [translate('_web_tournament_additional_settings')],
  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    feeRequierd: {
      get() {
        return this.$lodash.get(
          this.currentTournament,
          'entry_fee.required',
          false
        );
      },
      set(newVal) {
        this.updateCurrentTournament({
          required: newVal,
          component: 'entry_fee',
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>
